/// <reference types="vite-plugin-svgr/client" />
import { UnstyledButton } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import type { ManageBudgetsProps } from '@/components/ManageBudgets/ManageBudgets.types'
import { ManageBudgetsModal } from '@/components/ManageBudgetsModal/ManageBudgetsModal'

import PencilIcon from '@/assets/icons/pencil.svg?react'

import classes from './ManageBudgets.module.css'

export function ManageBudgets({ budgets }: ManageBudgetsProps) {
  const [opened, { close, open }] = useDisclosure(false)

  if (!budgets) return null

  return (
    <>
      <UnstyledButton className={classes.button} onClick={open}>
        <PencilIcon />
      </UnstyledButton>

      <ManageBudgetsModal budgets={budgets} onClose={close} opened={opened} />
    </>
  )
}
